<template>
    <div class="view view__course_edit">
        <course-edit/>
        <pop-notify
            ref="popNotify"
            :class="'pop__notify--redirect'"
            @emit-submit="redirect"
        />
    </div>
</template>

<script>
import CourseEdit from '@/components/ebs/courses/edit/CourseEdit'
import PopNotify from '@/components/default/shared/PopNotify'
import { allowRedirectBeforeRouteLeave } from '@/helpers/mixins'

export default {
  name: 'view-course-edit',
  components: { PopNotify, CourseEdit },
  mixins: [allowRedirectBeforeRouteLeave],
  computed: {
    isRouteCourse (data) {
      return this.$route.name.includes('ebs-course-edit')
    }
  },
  watch: {
    isRouteCourse () {
      this.$router.go(0)
    }
  },
  methods: {
    getCourseCertificate (data) {
      return this.$store.dispatch('ebsCertificateGet', { certificateId: data })
    },
    getCourse () {
      this.$store.dispatch('ebsCertificateClear')
      this.$store.dispatch('ebsModuleClear')
      this.$store.dispatch('ebsCatalogItemClear')

      const routeName = this.$route.name
      let dispatchName
      let dispatchParams

      if (routeName.includes('ebs-catalog-item-edit')) {
        dispatchName = 'ebsCourseGetVersion'
        dispatchParams = { courseId: this.$route.params.courseId, versionId: this.$route.params.versionId }
      } else if (routeName.includes('ebs-course-edit')) {
        dispatchName = 'ebsCourseGet'
        dispatchParams = { courseId: this.$route.params.id }
      }

      this.$eventBus.$emit('start-loading')
      this.$store.dispatch(dispatchName, dispatchParams).then(response => {
        const contentId = response.contentId
        if (contentId && this.isRouteCourse) {
          this.getCourseCertificate(contentId).finally(() => {
            this.$eventBus.$emit('stop-loading')
          })
        } else {
          this.$eventBus.$emit('stop-loading')
        }
      })
    }
  },
  created () {
    this.getCourse()
    this.$eventBus.$on('course-submit', this.allowRedirect)
  },
  beforeDestroy () {
    this.$eventBus.$off('course-submit')
  }
}
</script>
